import Backbone from 'backbone'
import template from './datasets-date-in-period-filter-step2.hbs'
import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import CalendarRangeSelector from 'scoreboard/components/calendar-range-selector'
import Dataset from 'scoreboard/datasets/model/dataset'
const { ALL_TIME } = Dataset

const DatasetsDateInPeriodFilterStep2 = Backbone.View.extend({
	className: 'datasets-date-in-period-filter-step2 filter-step',
	tagName: 'form',

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		let filter = this.options.filter
		let range = {
			calendarId: filter.calendarId
		}

		if (filter.periodId1) {
			range.relative = false
			range.first = filter.periodId1
			range.last = filter.periodId1
		} else {
			range.relative = true
			let period = _.isNil(filter.periodDelta1) ? 0 : filter.periodDelta1
			range.first = period
			range.last = period
		}

		this.periodSelector = new CalendarRangeSelector({
			range: range,
			canChangeCalendar: true,
			singlePeriod: true,
			allowAllTime: true,
			allowAppCalendar: true
		})

		this.$('.panel-content').append(this.periodSelector.el)
		this.periodSelector.render()

		this.options.wizard.render({
			el: this.el,
			stateSaver: this.saveState.bind(this)
		})

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false,
			allowCleanSubmission: true
		}).start({
			isNew: this.options.new
		})

		this.listenTo(this.periodSelector, 'change', this.formView.change.bind(this.formView))

		return this
	},

	context: function() {
		return {
			title: this.options.wizard.step2Title()
		}
	},

	saveState: function() {
		var filter = this.options.filter

		var val = this.periodSelector.val()
		filter.calendarId = val.calendarId

		if (val.calendarId == ALL_TIME) {
			delete filter.periodDelta1
			delete filter.periodId1
		} else if (val.relative) {
			filter.periodDelta1 = val.first
			delete filter.periodId1
		} else {
			filter.periodId1 = val.first
			delete filter.periodDelta1
		}

		this.options.wizard.options.filter = filter
	},

	submit: function() {
		this.saveState()
		this.options.wizard.finish()
		this.trigger('done')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.periodSelector, this.wizardProgress, this.formView], 'remove')
	}

})

export default DatasetsDateInPeriodFilterStep2

DatasetsDateInPeriodFilterStep2.__filename__ = 'datasets/filters/datasets-date-in-period-filter-step2.js'
